module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division II17.af5ca46f.png";